import './app.css';
// import '../assets/fonts/entero/font-style.css';
import '../assets/fonts/entero/demo';
import 'bootstrap';
// import './polyfills';
import 'core-js/es7/reflect';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

// depending on the env mode, enable prod mode or add debugging modules
if (process.env.NODE_ENV === 'production') {
    enableProdMode();
    // if (window) {
    //     window.console.log = function () { };
    // }
}

import { AppModule } from './app.module';

export function main() {
    return platformBrowserDynamic().bootstrapModule(AppModule);
}

if (document.readyState === 'complete') {
    main();
} else {
    document.addEventListener('DOMContentLoaded', main);
}
// $(document).ready(function () {
//     $(".dropdown").on("show.bs.dropdown", function (e) {
//         $(this)
//             .find(".dropdown-menu")
//             .first()
//             .stop(true, true)
//             .slideDown(400);
//     });

//     $(".dropdown").on("hide.bs.dropdown", function (e) {
//         $(this)
//             .find(".dropdown-menu")
//             .first()
//             .stop(true, true)
//             .slideUp(300);
//     });

//     $("button,span,a, .button-label").tooltip();


//     $("#menu").click(function() {
//         $("#wrapper").addClass("toggled");
//     });

//     $("#menu_remove").click(function() {
//         $("#wrapper").removeClass("toggled");
//     });

// });



